//#region src/csatStore.ts
var e = null, t = /* @__PURE__ */ new Set(), n = () => t.forEach((e) => e()), r = {
	open(t) {
		e || (e = {
			...t,
			stage: "toast"
		}, n());
	},
	promote(t) {
		!e || e.stage !== "toast" || (e = {
			...e,
			stage: "dialog",
			rating: t
		}, n());
	},
	close() {
		e && (e = null, n());
	},
	subscribe(e) {
		return t.add(e), () => {
			t.delete(e);
		};
	},
	getSnapshot() {
		return e;
	}
};
//#endregion
export { r as csatStore };
